export default __webpack_public_path__ + "static/media/people-keep-benefits-personalized-mobile.48a7f261.png";